import { UrlObject } from "node:url";
import BreadcrumbLink from "components/elements/Breadcrumbs/BreadcrumbLink";

export default function BreadcrumbRule(p: {
  readonly params: string[];
  readonly href: UrlObject;
}) {
  return <BreadcrumbLink href={p.href}>Rule</BreadcrumbLink>;
}
